<template>
<div>
<!--  <div style="margin: 0 20px"> <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addBed()">新增</el-button></div>-->
  <div style="margin: 10px 20px;height:360px;padding-bottom: 20px">
    <el-table :data="tableData" style="width: 100%" border height="100%">
      <el-table-column
        type="index"
        label="序号"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bed_name"
        label="床位名"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bed_num"
        label="床位号"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bed_fee"
        label="床位费"
        min-width="120"
        align="center">
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="createtime"-->
<!--        label="创建时间"-->
<!--        min-width="120"-->
<!--        align="center">-->
<!--      </el-table-column>-->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editRoomBed(scope.row)"></i>
<!--          <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delRoomBed(scope.row)"></i>-->
        </template>
      </el-table-column>
    </el-table>
  </div>
  <el-dialog width="600px" :title="titleName" :visible.sync="addEditShow" v-if="addEditShow" append-to-body center>
    <add-edit-bed :bedRow="bedRow" v-model="addEditShow" @updateTable="updateTable"></add-edit-bed>
  </el-dialog>
</div>
</template>

<script>
import addEditBed from './addEditBed'
import {queryhomebed, deletehomebed} from '../../../api/yanglaoyuan'

export default {
  name: 'openBedList',
  components: {addEditBed},
  model: {
    prop: 'bedShow',
    event: 'change'
  },
  props: {
    roomRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      titleName: '新增床位',
      addEditShow: false,
      bedRow: {
        isAdd: true,
        row: '',
        roomRow: ''
      }
    }
  },
  created () {
    this.bedRow.roomRow = this.roomRow.row
    this.updateTable()
  },
  methods: {
    updateTable () {
      let data = {
        hid: this.roomRow.row.id
      }
      queryhomebed(data).then(res => {
        this.tableData = res.data.homebed
      })
    },
    addBed () {
      this.titleName = this.roomRow.row.room + ' - 新增床位'
      this.bedRow.isAdd = true
      this.bedRow.row = ''
      this.addEditShow = true
    },
    editRoomBed (row) {
      this.titleName = this.roomRow.row.room + ' - 编辑床位'
      this.bedRow.isAdd = false
      this.bedRow.row = row
      this.addEditShow = true
    },
    delRoomBed (row) {
      let name = row.bed_num
      this.$confirm('此操作将永久删除该床位号【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletehomebed(data).then(res => {
          this.$notify({title: '成功', message: '成功删除床位', type: 'success', duration: 2000})
          this.updateTable()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/openBedList.vue